"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterAmenityGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
exports.defaultSfilterAmenityGroupState = {
    key: SfilterKey_1.SfilterKey.AMENITY,
    name: 'Amenities',
    opened: false,
    options: [
        { name: 'Outdoor Space', selected: false, key: 'outdoor-space' },
        { name: 'Maid\'s Room', selected: false, key: 'maid-room' },
        { name: 'Carpark', selected: false, key: 'carpark' },
    ],
};
